import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  bar: {
    background: theme.palette.navTab.bg,
    borderTopWidth: 0,
    borderBottomWidth: '1px',
    borderColor: theme.palette.navTab.border,
    borderBlockStyle: 'solid',
  },
  tabPanel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  tab: {
    display: 'inline-block',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '114.286%',
    letterSpacing: '1.25px',
    textTransform: 'uppercase',
    color: '#363636',
    textDecoration: 'none',
    padding: '24px 30px',
    position: 'relative',
    transition: 'all 0.4s ease-in-out',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&::after': {
      content: "' '",
      position: 'absolute',
      height: '2px',
      backgroundColor: '#33D6D4',
      bottom: 0,
    },
  },
  tabActive: {
    color: '#33D6D4',
    '&::after': {
      animation: '0.4s linear 1 alternate $animation',
      animationFillMode: 'forwards',
    },
  },

  '@keyframes animation': {
    '0%': {
      width: '0',
      left: '50%',
    },
    '100%': {
      width: '100%',
      left: 0,
    },
  },
}))
